import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Navbar 
      expand="lg" 
      className={`navbar ${scrolled ? 'scrolled' : ''}`} 
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <Navbar.Brand as={Link} to="/">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="logo"
          >
            <span>
            <img src="/logo.webp" alt="Website Logo" style={{ width: '30px', height: 'auto', borderRadius: '40%', marginRight: '10px' }} />
            </span>
            <span className="brand-name">NetworkBuilder</span>
          </motion.div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-toggler" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {[
              { path: '/', name: 'Home' },
              { path: '/about', name: 'About Us' },
              { path: '/portfolio', name: 'Portfolio' },
              { path: '/blog', name: 'Blog' },
              { path: '/testimonials', name: 'Testimonials' },
              { path: '/careers', name: 'Careers' },
              { path: '/contact', name: 'Contact' },
              { path: '/price', name: 'Pricing' },
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.1 * index }}
              >
                <Nav.Link 
                  as={NavLink} 
                  to={item.path}
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                  end
                >
                  {item.name}
                </Nav.Link>
              </motion.div>
            ))}
          </Nav>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            <Link to="/contact" className="btn btn-animated text-white" onClick={() => setExpanded(false)}>
              Get Started
            </Link>
          </motion.div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header; 